import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { EMPTY, finalize, first } from 'rxjs';
import { DriverResponse, DriversClient } from '../../shared';
import { LoadingDefaults } from '../../shared/models/loading-defaults.model';
import { RplLoadingService } from '../../shared/services/rpl-loading.service';

export const driverResolver: ResolveFn<DriverResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const client = inject(DriversClient);
  const loadingService = inject(RplLoadingService);
  const router = inject(Router);

  const driverId = Number(route.paramMap.get('driverId'));

  if (Number.isNaN(driverId)) {
    void router.navigate(['drivers']);
    return EMPTY;
  }

  let loadingId: string | undefined;
  const timeout = setTimeout(() => {
    loadingId = loadingService.start();
  }, LoadingDefaults.StartIndicatorTimeout);

  return client.getDriver(driverId).pipe(
    first(),
    finalize(() => {
      clearTimeout(timeout);
      loadingService.end(loadingId);
    }),
  );
};
